// §4.5 — query keys owned by the auth feature.
// Convention: ['auth', noun, ...args]

export const authKeys = {
  session: () => ["auth", "session"] as const,
  adminSession: () => ["auth", "admin-session"] as const,
};
